<template>
  <el-dialog title="Lagerbewegung erfassen"
    width="50%"
    :visible="show"
    @close="$emit('close')"
  >
    <div class="row">
      <div class="col-sm-12">
        <stock-rotations-form
          :init-product="product"
          :init-causes="causes"
          @stockRotationsCreated="$emit('close')"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import StockRotationsForm from 'src/pages/StockRotations/stock-rotations-form'

export default {
  props: ['show', 'product', 'causes'],
  components: {
    StockRotationsForm,
    [Dialog.name]: Dialog
  }
}
</script>

<style>
</style>
